var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValidationError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99995 10.9767C7.58895 10.9767 7.25577 11.3099 7.25577 11.7209C7.25577 12.1319 7.58895 12.4651 7.99995 12.4651C8.41096 12.4651 8.74414 12.1319 8.74414 11.7209C8.74414 11.3099 8.41096 10.9767 7.99995 10.9767Z",
    fill: "#DE3745"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44186 9.48837C7.44186 9.79661 7.69176 10.0465 8 10.0465C8.30824 10.0465 8.55814 9.79661 8.55814 9.48837H7.44186ZM8.55814 4.27907C8.55814 3.97082 8.30824 3.72093 8 3.72093C7.69176 3.72093 7.44186 3.97082 7.44186 4.27907H8.55814ZM14.8837 8C14.8837 11.8017 11.8017 14.8837 8 14.8837V16C12.4183 16 16 12.4183 16 8H14.8837ZM8 14.8837C4.19823 14.8837 1.11628 11.8017 1.11628 8H0C0 12.4183 3.58172 16 8 16V14.8837ZM1.11628 8C1.11628 4.19823 4.19823 1.11628 8 1.11628V0C3.58172 0 0 3.58172 0 8H1.11628ZM8 1.11628C11.8017 1.11628 14.8837 4.19823 14.8837 8H16C16 3.58172 12.4183 0 8 0V1.11628ZM8.55814 9.48837V4.27907H7.44186V9.48837H8.55814Z",
    fill: "#DE3745"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationError);
export default __webpack_public_path__ + "static/media/validationError.0112c2e759433ef6b1ad9fe396ad108b.svg";
export { ForwardRef as ReactComponent };